import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';
import { content } from './shared/routes/content.route';
import { AuthenticationLayoutComponent } from './shared/layouts/authentication-layout/authentication-layout.component';
import { authen } from './shared/routes/auth.route';
import { AuthCallbackComponent } from './features/auth/components/auth-callback/auth-callback.component';
import { LoginGuard } from './features/auth/guards/login.guard';

export const App_Route: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('../app/features/auth/components/b2c-login/b2c-login.component').then(
        (m) => m.B2cLoginComponent
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'UserVerify/AssignPwd',
    loadComponent: () =>
      import('../app/features/auth/components/assign-password/assign-password.component').then(
        (m) => m.AssignPasswordComponent
      ),
  },
  {
    path: 'auth/callback',
    component: AuthCallbackComponent,
    canActivate: [LoginGuard],
  },
  { path: '', component: MainLayoutComponent, children: content },
  { path: '', component: AuthenticationLayoutComponent, children: authen },
  { path: '**', redirectTo: '/error/error404', pathMatch: 'full' },
];
